import { render, staticRenderFns } from "./CostEditForm.vue?vue&type=template&id=20f61d7b"
import script from "./CostEditForm.vue?vue&type=script&lang=js"
export * from "./CostEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports